module.exports = __webpack_public_path__ + "media/images/emblems/Veyrier-coat_of_arms-2b0a0e160c543fc43287119aa389b8e9.svg";